<template>

  <div class="auth-fluid">
    <!--Auth fluid left content -->
    <div class="auth-fluid-form-box">
      <div class="align-items-center d-flex h-100">
        <div class="card-body">

          <!-- Logo -->
          <div class="auth-brand text-center text-lg-left">
              <span><img src="/static/logo.png" height="64" width="64"></span>
          </div>

          <!-- title-->
          <h4 class="mt-0">Logi sisse</h4>
          <p class="text-muted mb-4">4U Logistics arvete haldusvahend</p>


          <ul class="nav nav-tabs nav-justified nav-bordered mb-3">
            <li class="nav-item">
              <a class="nav-link" tabindex="0"
                 :class="{'active': mode === 'IdCard'}"
                 @click="setMode('IdCard')">ID kaardiga</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" tabindex="0"
                 :class="{'active': mode === 'MobileId'}"
                 @click="setMode('MobileId')">Mobiil ID</a>
            </li>
            <li class="nav-item">
              <a class="nav-link password-tab" tabindex="0"
                 :class="{'active': mode === 'Password'}"
                 @click="setMode('Password')">Parooliga</a>
            </li>
          </ul>

          <div v-if="errorMessage" class="alert alert-danger">
            {{$t(errorMessage)}}
          </div>

          <div class="auth-forms-wrapper">
            <div :class="{'d-none': mode !== 'MobileId'}">
              <form @submit.prevent="startMobileId">
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend" style="width: 72px">
                      <span class="input-group-text w-100 justify-content-center">+372</span>
                    </div>
                    <input type="text" v-model="phone" placeholder="Telefoninumber" class="form-control" autocomplete="phone">
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend" style="width: 72px">
                      <span class="input-group-text w-100 justify-content-center">EE</span>
                    </div>
                    <input type="text" v-model="personalCode" placeholder="Isikukood" class="form-control" >
                  </div>
                </div>
                <button type="submit" class="btn btn-primary btn-block"><i class="mdi mdi-login mr-1"></i>Logi sisse
                </button>
              </form>
              <div class="animate-scale-in-top" v-if="challenge">
                <h3 class="mt-3 mb-0 text-center">Kontrollkood - kas on {{challenge}}?</h3>
              </div>
            </div>

            <div :class="{'d-none': mode !== 'IdCard'}">
              <form>
                <p class="pt-2 mb-3 text-muted text-center">Enne jätkamist veendu, et ID-kaart on lugejas.</p>
                <button type="button" @click="idCardLogin" class="btn btn-primary btn-block"><i class="mdi mdi-login mr-1"></i>Logi sisse</button>
              </form>
            </div>

            <div :class="{'d-none': mode !== 'Password'}">
              <form @submit.prevent="checkPassword" id="password-form">
                <div class="form-group">
                  <input type="text" v-model="username" placeholder="Kasutajanimi" class="form-control" name="username" autocomplete="username">
                </div>
                <div class="form-group">
                  <input type="password" v-model="password" placeholder="Parool" class="form-control" name="password" autocomplete="current-password">
                </div>
                <button type="submit" class="btn btn-primary btn-block"><i class="mdi mdi-login mr-1"></i>Logi sisse</button>
              </form>
            </div>
          </div>

          <!-- Footer-->
          <footer class="footer footer-alt">
            <p class="text-muted"></p>
          </footer>

        </div> <!-- end .card-body -->
      </div> <!-- end .align-items-center.d-flex.h-100-->
    </div>
    <!-- end auth-fluid-form-box-->

    <!-- Auth fluid right content -->
    <div class="auth-fluid-right text-center"
         v-bind:style="{
          backgroundImage: 'url(/static/backdrops/bg-' + randomPictureId + '.jpg'
         }"
    >

    </div>
    <!-- end Auth fluid right content -->
  </div>
  <!-- end auth-fluid-->


</template>

<script>
  import store from '../services/store'

  export default {
    data() {
      return {
        phone: null,
        personalCode: null,
        challenge: null,

        username: null,
        password: null,

        mode: 'IdCard',
        errorMessage: null
      }
    },
    methods: {
      startMobileId() {
        this.errorMessage = null
        this.$gateway.post('/authentication/mobile-id/start', {phone: this.phone, personalCode: this.personalCode}).then(r => {
          this.challenge = r.data
          this.startMobileIdPolling()
        }).catch(r => this.handleError(r.response.data))
      },
      startMobileIdPolling() {
        setTimeout(() => {
          this.$gateway.get('/authentication/mobile-id/status').then(r => {
            let loggedIn = r.data
            if (loggedIn) {
              this.handleSuccess(r)
            } else {
              this.startMobileIdPolling()
            }
          }).catch(r => this.handleError(r.response.data))
        }, 2000)
      },
      handleError(response) {
        this.errorMessage = response.key
        this.challenge = null
      },
      handleSuccess(response) {
        store.commit('user', response.data)
        store.commit('env', response.data.env)
        this.$router.replace('/')
      },
      checkPassword() {
        this.$gateway.post('/authentication/password', {username: this.username, password: this.password})
          .then(this.handleSuccess)
          .catch(r => this.handleError(r.response.data))
      },
      idCardLogin() {
        this.errorMessage = null
        this.$gateway.get('/authentication/id-card')
          .then(this.handleSuccess)
          .catch(r => this.handleError(r.response.data))
      },
      setMode(mode) {
        this.mode = mode
        setTimeout(this.focusInput)
      },
      focusInput() {
        let input = this.$el.querySelector('input')
        if (input && input.focus) input.focus()
      }
    },
    watch: {
      mode() {
        this.errorMessage = null
      }
    },
    computed: {
      randomPictureId() {
        const maxValue = 10;
        return  Math.floor(Math.random() * maxValue) + 1;
      }
    },
  }
</script>
